"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = exports.clearCookies = void 0;

var _index = require("../index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ HELPER FUNCTIONS ++++++++++ */


var deleteCookie = function deleteCookie(name) {
  document.cookie = name + "=; Path=/;".concat(_index.url.baseURL === 'localhost' ? '' : " Domain=.".concat(_index.url.baseURL, ";"), " Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */


var clearCookies = function clearCookies(cookies) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = cookies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var cookie = _step.value;
      deleteCookie(cookie);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

exports.clearCookies = clearCookies;

var getCookie = function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
};

exports.getCookie = getCookie;